import type { FaireProductEntity } from "../../entity_types/product";

export const p_6cadgmqvgc: FaireProductEntity = {
  token: "p_6cadgmqvgc",
  type: "product",
  name: "A Martini Changes Everything Gym Crew Socks",
  brandToken: "b_1fc44661",
  brandName: "Gumball Poodle",
  imageUrl: "https://cdn.faire.com/fastly/4fe3990988fa1ab58e514168061d78f7fb7fa39bae14bd9748dc2b04a31c7dc6.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/f36b473e3f18a8e5060efe40a7dea7f0b01910de4ce4a5f628773e7caf31e7ea.jpeg",
    "https://cdn.faire.com/fastly/bdc2784d5af63261ca5b8fea54de3961301cd67ee35ffe889e55757d250f0ba7.jpeg",
    "https://cdn.faire.com/fastly/e905299ebf60a9a716c18bd0d111c686e98f2685ae50ec17f954482488815cd4.jpeg",
    "https://cdn.faire.com/fastly/8e3a386b86a5e76730e329b70dcaa1fafc3893faca18db0a3fc1c00e48a22c92.jpeg",
    "https://cdn.faire.com/fastly/68ecf16753ec49dba22b4484cd8aba44379104264b03b2c09dcfd3151b718797.jpeg"
  ],
  priceDollars: 6.75,
  description: "Limited Availability - Will Not Restock\n\nThese socks won't promise solutions, but a martini definitely makes things... different. 🥴 🍸\n\nGumball Poodle is GPSR compliant! We will automatically be stickering all orders into the EU or Northern Ireland for GPSR compliance. \n\nIf you are in the UK but sell into the EU, we can provide you with the necessary stickers to put on products - be sure to tell us you need these when you place your order.",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-12T05:28:06.653Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
